<wo-details-box
  [primary]="presentedName$ | async"
  [secondary]="ewcCode$ | async"
/>
